import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface NoConnectionScreenProps {
  visible: boolean;
}

export function NoConnectionScreen({ visible }: NoConnectionScreenProps) {
  const { t } = useTranslation('common');

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 9999,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100dvh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <WifiOffIcon sx={{ fontSize: 64, color: '#0F172A' }} />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
        }}
      >
        {t('noConnection')}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          textAlign: 'center',
          px: 4,
        }}
      >
        {t('noConnectionSubtitle')}
      </Typography>
    </Box>
  );
}
